import { useEffect } from "react";
import inventario from "../api/inventario";
import { useConfiguracionStore } from "../hooks/useConfiguracionesStore";

export const useConfiguracion = () => {
  const { configuracion, setConfiguracion } = useConfiguracionStore();

  useEffect(() => {
    const fetch = async () => {
      try {
        const config = await inventario.getConfiguracion(); //  ahora es objeto directo
        setConfiguracion(config);
      } catch (error) {
        console.error(" Error al obtener configuración", error);
      }
    };

    if (!configuracion) {
      fetch();
    }
  }, [configuracion, setConfiguracion]);

  return { configuracion };
};
